import React, { createContext, useContext, useState, useMemo } from 'react';

interface DashboardContextType {
    botName: string;
    setBotName: (name: string) => void;
    avatarEmoji: string;
    setAvatarEmoji: (emoji: string) => void;
}

const DashboardContext = createContext<DashboardContextType | undefined>(undefined);

export function DashboardProvider({ children }: { children: React.ReactNode }) {
    const [botName, setBotName] = useState("My Project");
    const [avatarEmoji, setAvatarEmoji] = useState("🤖");

    const value = useMemo(() => ({
        botName,
        setBotName,
        avatarEmoji,
        setAvatarEmoji
    }), [botName, avatarEmoji]);

    return (
        <DashboardContext.Provider value={value}>
            {children}
        </DashboardContext.Provider>
    );
}

export function useDashboard() {
    const context = useContext(DashboardContext);
    if (!context) {
        throw new Error("useDashboard must be used within a DashboardProvider");
    }
    return context;
}
